import { Filter } from '@cubejs-client/core';

import { DimPurchaseOrderItemField } from '~/common/types/cubes/DimPurchaseOrderItem';
import { useModuleContext } from '~/components/ModuleContextProvider';

import { PurchaseOrderVolumeWidget } from './PurchaseOrderVolumeWidget';

export const CommodityGroupPurchaseOrderVolumeWidget = () => {
  const { entityId } = useModuleContext();
  const filters: Filter[] = [
    {
      member: DimPurchaseOrderItemField.COMMODITY_GROUP_ID,
      operator: 'equals',
      values: [entityId],
    },
  ];
  return <PurchaseOrderVolumeWidget filters={filters} />;
};
